export default "__VITE_ASSET__BfdXL_RP__"